<style lang="scss">
  @import '../resources/scss/project_details.scss';
</style>

<script lang="ts">
  import type MenuIcon from '../api/rest/directus-cms/menus/model/MenuIcon'
  import type Projects from '../api/rest/directus-cms/projects/model/Projects'
  import { Darkness } from '../config/colors'
  import ProjectCircle from './Project_Circle.svelte'
  import ProjectHeaderDetails from './Project_Header_Details.svelte'
  export let p: Projects
  export let color_class: string

  const projectImage: MenuIcon | null = p.translations[0].circle_image ?? null
</script>

<div class="container-fluid bg-{Darkness.DARK}-{color_class}">
  <div class="container-xxl flex-grow-1">
    <div class="row {p.brand_logo?.fullUrl ? 'details' : 'no-img-details'}">
      <div class="col-12">
        <div class="d-flex logo-brand mb-3 mb-lg-0 justify-content-end">
          {#if p.brand_logo?.fullUrl}
            <img class="mb-1" src={p.brand_logo?.fullUrl} alt={p.translations[0].name} />
          {/if}
        </div>
        <ProjectHeaderDetails {p} />
        {#if projectImage}
          <ProjectCircle image={projectImage} />
        {/if}
      </div>
    </div>
  </div>
</div>
